export const LOCAL_ENV_HOSTS = ['127.0.0.1', 'localhost', '0.0.0.0'];

export function isLocalEnvHost(host: string) {
  return LOCAL_ENV_HOSTS.some((localHost) => host.includes(localHost));
}
